var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSavedSimulation = function SvgSavedSimulation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.62,
    height: 18.62,
    viewBox: "0 0 18.62 18.62",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-_7_zapisane_symulacje"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.62,
    height: 18.62
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_7_zapisane_symulacje",
    "data-name": "7 zapisane symulacje",
    clipPath: "url(#clip-_7_zapisane_symulacje)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "diskette"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_340",
    "data-name": "Group 340"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_339",
    "data-name": "Group 339"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M151.545,303.091h6.545a.545.545,0,1,0,0-1.091h-6.545a.545.545,0,1,0,0,1.091Z",
    transform: "translate(-145.51 -291.019)",
    fill: "#a8b0b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M151.545,363.091h6.545a.545.545,0,1,0,0-1.091h-6.545a.545.545,0,1,0,0,1.091Z",
    transform: "translate(-145.51 -348.838)",
    fill: "#a8b0b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M18.456,3.069,15.548.16A.545.545,0,0,0,15.162,0H.545A.545.545,0,0,0,0,.545V18.071a.545.545,0,0,0,.545.545H18.071a.545.545,0,0,0,.545-.545V3.454A.545.545,0,0,0,18.456,3.069ZM4.4,1.091h7.636V4.727H4.4Zm9.817,16.435H4.4V9.89h9.817Zm3.309,0H15.307V9.344a.545.545,0,0,0-.545-.545H3.854a.545.545,0,0,0-.545.545v8.181H1.091V1.091H3.309V5.272a.545.545,0,0,0,.545.545H12.58a.545.545,0,0,0,.545-.545V1.091h1.81L17.525,3.68Z",
    fill: "#a8b0b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M151.545,423.091h6.545a.545.545,0,1,0,0-1.091h-6.545a.545.545,0,1,0,0,1.091Z",
    transform: "translate(-145.51 -406.656)",
    fill: "#a8b0b6"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSavedSimulation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/saved_simulation.ba822883.svg";
export { ForwardRef as ReactComponent };